export enum ChartDefinition
{
    DriverCan,
    Temperature
}

